import React from "react";
import PageLayout from "../components/PageLayout";

export default function Equipe() {
  const cards = [
    {
      title: "Coordenação pedagógica",
      text: "Garante a qualidade dos programas, métodos de ensino e acompanhamento dos formandos.",
      points: ["Planeamento", "Supervisão", "Melhoria contínua"],
    },
    {
      title: "Formadores",
      text: "Profissionais com experiência que ligam conceitos, prática e realidade do mercado angolano.",
      points: ["Domínio técnico", "Didáctica", "Mentoria"],
    },
    {
      title: "Equipa técnica e criativa",
      text: "Especialistas responsáveis por tecnologia, produção gráfica e execução dos projectos.",
      points: ["Precisão", "Criatividade", "Cumprimento de prazos"],
    },
  ];
  return (
    <PageLayout
      eyebrow="A nossa equipa"
      title="Pessoas experientes, próximas e comprometidas."
      intro="O trabalho do CENFOTEP é feito por profissionais que gostam de ensinar, resolver e criar. Cada área partilha o mesmo padrão de rigor e atenção ao cliente."
      sectionTitle="Competências que trabalham em conjunto"
      sectionIntro="A colaboração entre pedagogia, tecnologia, atendimento e produção permite-nos acompanhar projectos de diferentes dimensões."
      cards={cards}
    />
  );
}
